<template>
    <div class="right-block">
        <div class="right-block-top">
            <div class="right-block-1">
                <h5 class="title-5">
                    {{numberToCurrency(stats.raised_amount)}} raised of {{numberToCurrency(stats.goal_amount)}}
                </h5>
            </div>
        </div>
        <div class="progress skill-bar" style="height: 5px;">
            <div class="progress-bar progress-bar-success" role="progressbar" :style="'width: '+raisedPercentage+'%;'"
                 :aria-valuenow="raisedPercentage" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
        <div class="right-block-2" v-cloak v-show="stats.donors_count == 0">
            <span><strong>Be the first to donate to this fund!</strong> </span>
        </div>

        <div class="right-block-2" v-cloak v-show="fundraiser.completed_at == '' && stats.donors_count > 0">
            <span><strong> {{raisedPercentage}}% </strong>  raised by <strong>{{stats.donors_count}} </strong> people in <strong>{{stats.publish_time}}</strong> </span>
        </div>

        <div class="right-block-2" v-cloak v-show="fundraiser.completed_at != ''">
            <span><strong> {{raisedPercentage}}% </strong>  raised by  <strong>{{stats.donors_count}} </strong> people <strong>{{fundraiser.completed_at}}</strong> </span>
        </div>

        <div class="right-block-bottom">
	        
            <checkout
                :fundraiser="fundraiser"
                v-show="ready"
                :fundraiser-id="fundraiser.id"
                :goal="stats.goal_amount"
                :raised="stats.raised_amount"
                v-if="stats.goal_amount!==undefined">
            </checkout>
            
	        <div class="fund-share">
                <span>Share this fund</span>
                <ul>
                    <li>
                        <a :href="getTwitterLink()" target="_blank">
                            <i class="fab fa-twitter-square" aria-hidden="true"></i>
                        </a>
                    </li>
                    <li>
                        <a :href="getFacebookLink()" target="_blank">
                            <i class="fab fa-facebook-square" aria-hidden="true"></i>
                        </a>
                    </li>
                    <li><a :href="customMailTo" target="_blank"><i class="fa fa-envelope" aria-hidden="true"></i></a></li>

                    <li><a href="javascript: void(0)" onclick="print()"><i class="fa fa-print"></i></a></li>
                </ul>
            </div>
        </div>

        <funding-donators :fundraiser-id="fundraiser.id"></funding-donators>
    </div>
</template>

<script>
    export default {
        props: {
            fundraiser: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                stats: {
                    donors_count:0,
                    goal_amount:0,
                    publish_time:"",
                    raised_amount:0,
                },
                routes: {},
                ready:false,
            }
        },
        mounted() {
            window.kinfEvents.$on('FundraiserDetails:sendRoutes', (routes) => {
                this.routes = routes;
                let raiseUrl = this.routes.fundraiser_raised_amount.replace('FID', this.fundraiser.id);
                window.axios.get(raiseUrl)
                    .then((response) => {
                        this.ready = true;
                        this.stats = response.data.data;
                    });
            });
        },
        computed: {
            raisedPercentage() {
                return Math.floor(this.stats.raised_amount * 100 / this.stats.goal_amount);
            },
            customMailTo(){
                return  "mailto:?subject=Help teachers get the supplies they desperately need&body=Please help "+this.fundraiser.name+"'s classroom reach their funding goal for a #ClassroomSupplyBox! "+
                    this.routes.app+this.routes.fundraiser_show+'/'+this.fundraiser.slug    ;

            }
        },
        methods: {
            clickOutsideCheckout(){
                kinfEvents.$emit('OutsideClick:checkout');
            },
            getTwitterLink() {
                let url = 'https://twitter.com/intent/tweet?';

                url += "text=Please help " + this.fundraiser.name + "\'s classroom reach their funding goal for a %23ClassroomSupplyBox!";
                url += '&url=' + this.getShareUrl();

                return url;
            },
            getFacebookLink() {
                let url = 'https://www.facebook.com/sharer/sharer.php?u=';
                url += this.getShareUrl();
                return url;
            },
            getShareUrl() {
                return '' + this.routes.app + '/fundraiser/' + this.fundraiser.slug;
            },
            numberToCurrency(number) {
                let formatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 2,
                    // the default value for minimumFractionDigits depends on the currency
                    // and is usually already 2
                });

                return formatter.format(number).replace('$', '$ ');
            }
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// resources/js/views/fundraisers/components/show/FundingDetails.vue